import React, { useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CardEvent } from "../../";
import styles from "./styles.module.scss";
import { mediaQueries } from "../../../constant";
import { iconChevron } from "../../../assets/images";

export default function SliderSlickEvent({ showContent, data, classCustom }) {
  const isBiggerScreen = useMediaQuery({
    query: `(min-device-width: ${mediaQueries?.tablet}px)`,
  });

  const variantContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
        },
      },
    }),
    []
  );

  function CustomArrow(props) {
    const { className, style, onClick } = props;
    return (
      <span
        className={clsx(
          "border rounded-full flex items-center justify-center",
          className,
          styles.arrow
        )}
        style={{ ...style }}
        onClick={onClick}
      >
        <div className="flex w-full h-full a items-center justify-center">
          <img src={iconChevron} alt="icon-chevron" style={{ width: 15 }} />
        </div>
      </span>
    );
  }

  const settings = useMemo(
    () => ({
      focusOnSelect: true,
      slidesToShow: isBiggerScreen ? 3.3 : 1.3,
      slidesToScroll: 1,
      infinite: false,
      nextArrow: <CustomArrow />,
      prevArrow: <CustomArrow />,
      customPaging: function (i) {
        return (
          <motion.a
            // variants={variantDots}
            initial="offScreen"
            // whileInView={showElement ? "onScreen" : "offScreen"}
            className={clsx({
              "ml-2 lg:ml-4": i !== 0,
            })}
          >
            <h4 className="text-xl lg:text-3xl font-bold">{data?.[i]?.year}</h4>
          </motion.a>
        );
      },
    }),
    [isBiggerScreen]
  );

  return (
    <motion.div
      variants={variantContainer}
      initial="offScreen"
      whileInView={showContent ? "onScreen" : "offScreen"}
      className={clsx(classCustom, styles.slider)}
    >
      <Slider {...settings} className={clsx(styles.sliderContainer)}>
        {data?.map((item, index) => (
          <CardEvent
            key={index}
            item={item}
            index={index}
            showContent={showContent}
          />
        ))}
      </Slider>
    </motion.div>
  );
}
